import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { LangDefinition, TranslocoPipe, TranslocoService } from "@ngneat/transloco";

@Component({
  selector: "languages",
  templateUrl: "./languages.component.html",
  exportAs: "languages",
  standalone: true,
  imports: [MatButtonModule, MatMenuModule, MatTooltipModule, TranslocoPipe],
})
export class LanguagesComponent {
  private _translocoService = inject(TranslocoService);

  availableLangs = this._translocoService.getAvailableLangs() as LangDefinition[];
  activeLang = this._translocoService.getActiveLang();

  setActiveLang(lang: string): void {
    this._translocoService.setActiveLang(lang);
    this.activeLang = lang;
  }
}
